import {useSelector} from "react-redux";
import {assetTypeToGroup, getSpecificAsset} from "../../ducks/assets-duck.js";
import InternalLink from "../util/navigation/InternalLink.jsx";
import {APP_ROUTES} from "../../App.jsx";
import './Asset.scss'
import Counter from "../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../util/numbers.js";
import DirectionIcon from "../util/icons/DirectionIcon.jsx";
import AssetListIcon from "../util/icons/AssetListIcon.jsx";
import {getDirectionColorClassName} from "../../util/misc.js";

export default ({
                    asset_id,
                    max,
                    min,
                    max_usd,
                    min_usd,
                    rate_60_min,
                    rate_usd_60_min
                }) => {
    const {
        code,
        name,
        asset_type: assetType = '',
        is_usd_asset,
        currentRate,
        currentRateUsd
    } = useSelector(state => getSpecificAsset(state, asset_id))

    const oneHourRange = max - min
    const currentToMinRange = currentRate - min
    const ratio = currentToMinRange / oneHourRange

    const oneHourRangeUsd = max_usd - min_usd
    const currentToMinRangeUsd = currentRateUsd - min_usd
    const ratioUsd = currentToMinRangeUsd / oneHourRangeUsd

    const oneHourChangePct = (currentRate - rate_60_min) / rate_60_min
    const oneHourChangePctUsd = (currentRateUsd - rate_usd_60_min) / rate_usd_60_min
    const relevantChangePct = is_usd_asset ? oneHourChangePctUsd : oneHourChangePct

    let relevantRatio = is_usd_asset ? ratioUsd : ratio
    if (relevantRatio >= .9) {
        relevantRatio = 1
    }
    if (relevantRatio <= .1) {
        relevantRatio = 0
    }

    const directionClassName = getDirectionColorClassName(relevantChangePct, true)

    return (
        <li>
            <InternalLink
                to={APP_ROUTES.stats.replace(':filterId', asset_id)}
                className='hot-asset'
                icon={
                    <span className={`icon-ring ${directionClassName}`}>
                        <AssetListIcon name={name} assetGroup={assetTypeToGroup(assetType)}/>
                    </span>
                }
                isIconGolden={false}
            >
                <div className={`flex-vertical-center change ${directionClassName}`}>
                    <DirectionIcon value={relevantChangePct / 100} isMultiColored={true}/>
                    <Counter
                        absolute={true}
                        amount={relevantChangePct * 100}
                        decimals={DECIMAL_FORMAT.FLEX_PERCENTAGE}
                        suffix={'%'}
                    />
                    <span className='span'>
                        {code}
                    </span>
                </div>
                <div className='bar'>
                    <div
                        className='up-side'
                        style={{
                            "--borderWidth": relevantRatio === 1 || relevantRatio === 0 ? 0 : "2px",
                            "--width": `${relevantRatio * 100}%`,
                        }}
                    />
                </div>
            </InternalLink>
        </li>
    )
}
